"use client";
import { jsx } from "react/jsx-runtime";
import { TextBelowInput } from "./internal/TextBelowInput.js";
import { ValidationText } from "./internal/ValidationText.js";
function InputHelperText({ id, helperText, validity = { type: "none" }, reserveSpaceForMessage = true, disabled, className }) {
  if (validity.type !== "none" && validity.message) {
    return jsx(ValidationText, { className, id, validationState: validity.type, message: validity.message, disabled });
  }
  if (helperText) {
    return jsx(TextBelowInput, { className, id, isDisabled: disabled, children: helperText });
  }
  if (reserveSpaceForMessage) {
    return jsx(TextBelowInput, { className, isDisabled: disabled, children: " " });
  }
  return null;
}
function useInputHelperText(props) {
  const { validity, id } = props;
  const inputAriaProps = {
    ...(validity == null ? void 0 : validity.type) === "error" && {
      "aria-invalid": true,
      "aria-errormessage": id
    },
    "aria-describedby": id
  };
  return {
    helperTextProps: props,
    inputAriaProps
  };
}
export {
  InputHelperText,
  useInputHelperText
};
